export const docTextPolishToLocalDataTransfer = (data: any) => {
  const transTextPolishDoc = data?.map((item) => {
    return {
      st: item.start,
      et: item.end,
      pi: item.paragraphId,
      sentence_ids: item.sentenceIds,
      formal_paragraph: item.formalParagraphText,
      formal_validity: true,
    };
  });
  return transTextPolishDoc;
};
